import BaseService from "src/packages/BaseService";

export default class NotificationService extends BaseService {
	static get className() {
		return "notification";
	}
};
